document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-nm-cookie-preferences]') : null;
  if (!button) return;
  const status = document.getElementById(button.getAttribute('aria-describedby'));
  const fail = () => { if (status) status.hidden = false; };
  if (status) status.hidden = true;
  const banner = window.privacyBanner;
  if (!banner || typeof banner.showPreferences !== 'function') {
    fail();
    return;
  }
  button.disabled = true;
  try {
    await banner.showPreferences();
  } catch (error) {
    fail();
  } finally {
    button.disabled = false;
  }
});
